/* global ga */

import Raven from 'raven-js';
import calendarView from './calendarView';
import appointmentView from './appointmentView';
import { createEl, createBtn, toggle } from '../helpers/domHelpers';
import { widgetCtrl as ctrl } from '../widgetController';
import { setPrimaryColors, setPrimaryFontColor, getThemeClass } from '../helpers/setColors';
import styles from '../css/widgetModal.css';

const widgetModal = {
  init() {
    this.spinner = createEl('div', styles.spinner);
    this.error = createEl('div', styles.error);
    const errorOk = createEl('button', styles.errorButton, 'OK');
    this.error.append(
      createEl('p', styles.errorText, 'Sorry, something went wrong. \nPlease try again.'),
      errorOk,
    );
    errorOk.addEventListener('click', this.render.bind(this));


    this.calendarViewElem = calendarView.init();
    this.appointmentViewElem = appointmentView.init();
    const modalContainer = createEl('div', styles.container);

    const body = createEl('div', styles.body);
    body.append(
      this.calendarViewElem,
      this.appointmentViewElem,
    );
    const header = setPrimaryColors(createEl('div', styles.header));
    const closeX = setPrimaryFontColor(createBtn(styles.closeBtn, 'close'));
    const name = setPrimaryFontColor(
      createEl('h2', styles.officeName, ctrl.getPracticeName()),
    );
    header.append(
      name,
      closeX,
    );

    this.modal = createEl('div', styles.modal);
    this.modal.append(
      header,
      createEl('div', styles.divider),
      body,
    );

    const themeClass = getThemeClass();
    this.modal.className += ` ${themeClass}`;

    modalContainer.append(
      this.modal,
      this.spinner,
      this.error,
    );
    return modalContainer;
  },

  toggleSpinner() {
    this.spinner.style.display = this.spinner.style.display === 'block' ?
      'none' :
      'block';
  },

  showError(errorText) {
    this.error.childNodes[0].textContent = errorText;
    this.error.style.display = 'flex';
    this.modal.style.filter = 'blur(3px)';
  },

  onAppointmentTimeClick(booking) {
    // Google Analytics:
    if (process.env.NODE_ENV === 'production') {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Calendar',
        eventAction: 'timeSelect',
      });
    }
    this.toggleSpinner();
    ctrl.holdBooking(booking)
    .then(() => {
      toggle(widgetModal.calendarViewElem, widgetModal.appointmentViewElem);
      appointmentView.render();
      setTimeout(this.toggleSpinner.bind(this), 100);
    }).catch((err) => {
      Raven.captureException(err);
    });
  },

  onEditAppointmentClick() {
    // Google Analytics:
    if (process.env.NODE_ENV === 'production') {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Form',
        eventAction: 'back',
      });
    }
    toggle(widgetModal.appointmentViewElem, widgetModal.calendarViewElem);
    window.dispatchEvent(new Event('resize'));
  },

  render() {
    this.spinner.style.display = 'none';
    this.error.style.display = 'none';
    this.modal.style.filter = 'blur(0px)';
    toggle(this.appointmentViewElem, this.calendarViewElem);
    appointmentView.clearForm();
    calendarView.render();
  },
};

export default widgetModal;



// WEBPACK FOOTER //
// ./src/views/widgetModal.js